var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m214.139 201.43c8.284 0 15-6.716 15-15 0-53.172 43.259-96.43 96.431-96.43 8.284 0 15-6.716 15-15s-6.716-15-15-15c-69.714 0-126.431 56.716-126.431 126.43 0 8.284 6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.819 507.606c5.857 5.858 15.355 5.859 21.213 0l117.932-117.933c5.858-5.858 5.858-15.355 0-21.213l-10.602-10.602 29.423-29.428c33.686 28.64 76.025 44.43 120.79 44.43 102.795 0 186.425-83.634 186.425-186.435-.001-102.795-83.631-186.425-186.426-186.425-102.8 0-186.435 83.63-186.435 186.425 0 44.875 15.863 87.189 44.433 120.792l-29.422 29.428-10.611-10.611c-5.854-5.855-15.357-5.857-21.213 0l-117.933 117.933c-5.854 5.853-5.858 15.356 0 21.213zm122.32-321.181c0-86.253 70.177-156.425 156.435-156.425 86.253 0 156.425 70.172 156.425 156.425 0 86.259-70.172 156.435-156.425 156.435-86.258 0-156.435-69.907-156.435-156.435zm-36.207 171.429 21.213 21.213-96.719 96.719-21.214-21.213z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.e3e6f7da93f04490b7752f86a34ab346.svg";
export { ForwardRef as ReactComponent };